
interface TodayConsumptionProps {
  data: any;
}

export function TodayConsumption({ data }: TodayConsumptionProps) {
  if (!data) return null;

  return (
    <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl shadow-sm p-6 border-2 border-blue-200 hover:shadow-lg transition-all duration-300">
      <div className="flex items-center justify-between mb-4">
        <div className="bg-gradient-to-br from-blue-500 to-blue-600 w-12 h-12 rounded-lg flex items-center justify-center shadow-lg">
          <i className="ri-home-4-line text-white w-6 h-6 flex items-center justify-center text-2xl"></i>
        </div>
        <div className="text-right">
          <div className="text-xs text-blue-600 font-semibold bg-blue-100 px-2 py-1 rounded-full">
            CONSUMO
          </div>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-gray-700 mb-3">
        Consumo del Hogar
      </h3>

      <div className="space-y-3">
        <div>
          <div className="flex items-baseline space-x-1 mb-1">
            <span className="text-3xl font-bold text-blue-700">
              {data.total.toFixed(1)}
            </span>
            <span className="text-sm font-semibold text-blue-600">kWh</span>
          </div>
          <p className="text-xs text-gray-600">Total consumido hoy</p>
        </div>

        <div className="grid grid-cols-2 gap-3 pt-3 border-t border-blue-200">
          <div>
            <div className="text-lg font-bold text-blue-700">
              {data.peak.toFixed(1)}
            </div>
            <p className="text-xs text-gray-600">Pico (kW)</p>
            <p className="text-xs text-blue-600 font-medium">{data.peakTime}</p>
          </div>
          
          <div>
            <div className="text-lg font-bold text-blue-700">
              {data.baseLoad.toFixed(1)}
            </div>
            <p className="text-xs text-gray-600">Carga base</p>
            <p className="text-xs text-blue-600 font-medium">kW</p>
          </div>
        </div>
      </div>

      {/* Gráfico de consumo por horas */}
      <div className="mt-4">
        <div className="flex items-center justify-between text-xs text-gray-600 mb-2">
          <span>Patrón diario</span>
          <span>24h</span>
        </div>
        <div className="flex items-end space-x-1 h-8">
          {Array.from({ length: 24 }, (_, i) => {
            let height = 20; // Base
            if (i >= 6 && i <= 9) height = 60; // Mañana
            if (i >= 12 && i <= 14) height = 40; // Mediodía
            if (i >= 18 && i <= 22) height = 80; // Noche
            
            return (
              <div
                key={i}
                className="bg-blue-400 rounded-t-sm flex-1 transition-all duration-300 hover:bg-blue-500"
                style={{ height: `${height}%` }}
                title={`${i}:00 - ${((height / 100) * data.peak).toFixed(1)}kW`}
              ></div>
            );
          })}
        </div>
      </div>

      <div className="mt-4 flex items-center space-x-2">
        <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
        <span className="text-xs text-gray-600 font-medium">Monitoreo continuo</span>
      </div>
    </div>
  );
}
